import { createGlobalStyle } from "styled-components";

const tokens = {
	"--gray-1": "#f6f6f8",
	"--gray-2": "#e2e2e6",
	"--gray-3": "#ceced4",
	"--gray-4": "#bbbbc3",
	"--gray-5": "#a8a8b2",
	"--gray-6": "#9596a1",
	"--gray-7": "#838490",
	"--gray-8": "#717280",
	"--gray-9": "#5f6170",
	"--gray-10": "#4e5061",
	"--gray-11": "#3d4052",
	"--gray-12": "#2d3143 !important",
	"--gray-a1": "#f6f6f803",
	"--gray-a2": "#e2e2e606",
	"--gray-a3": "#ceced40f",
	"--gray-a4": "#bbbbc317",
	"--gray-a5": "#a8a8b21f",
	"--gray-a6": "#9596a126",
	"--gray-a7": "#83849031",
	"--gray-a8": "#71728044",
	"--gray-a9": "#5f617072",
	"--gray-a10": "#4e50617c",
	"--gray-a11": "#3d40529b",
	"--gray-a12": "#2d3143df",
	"--signal-record": "#ff0000",
	// Danger: the one functional color besides signal-record. Reserved for
	// destructive actions (delete, discard) and error states. A deep crimson,
	// tuned so Signal White label text clears WCAG AA (#f6f6f8 on #ca244d ≈
	// 4.9:1); the deeper-than-pink tone also reads as "warning" rather than
	// candy in the dim performance context. Applied identically to the danger
	// AppButton and the shared DangerIconButton so destruction is always one red.
	"--color-danger": "#ca244d",
	"--color-danger-hover": "#b81e44",
	"--color-danger-active": "#a51a3c",
	"--color-danger-contrast": "var(--gray-1)",
	// A light rose for danger text/icons on the dark surface (the solid crimson
	// is unreadable as small text here; this clears AA on --gray-12).
	"--color-danger-text": "#ff9aac",
	"--color-danger-surface": "color-mix(in srgb, #ca244d 16%, transparent)",
	"--color-danger-border": "color-mix(in srgb, #ca244d 38%, transparent)",
	"--color-surface": "var(--gray-12)",
	"--color-surface-raised": "var(--gray-11)",
	"--color-surface-mid": "var(--gray-10)",
	"--color-border": "var(--gray-9)",
	"--color-text": "var(--gray-2)",
	"--color-text-primary": "var(--gray-1)",
	"--color-text-secondary": "var(--gray-3)",
	"--color-text-placeholder": "var(--gray-5)",
	"--color-text-disabled": "var(--gray-4)",
	"--color-backdrop-overlay":
		"color-mix(in srgb, var(--gray-1) 50%, transparent)",
	"--color-drag-overlay": "color-mix(in srgb, var(--gray-12) 8%, transparent)",
};
export const GlobalTheme = createGlobalStyle({
	":root": {
		...tokens,
		color: "var(--gray-1)",
	},
	":where(.radix-themes)": {
		...tokens,
		color: "var(--gray-1)",
	},
	"*:not(input):not(textarea):not(select):not(a)": {
		userSelect: "none",
	},
	"*:not(input):not(textarea):not(select):not(a)::selection": {
		backgroundColor: "transparent",
	},
	"*:not(body):not(::root):not(.rt-ScrollAreaViewport):not(.rt-ScrollAreaRoot):not(:has(.rt-ScrollAreaRoot))":
		{
			touchAction: "manipulation",
		},
	"@media (prefers-reduced-motion: reduce)": {
		"*, *::before, *::after": {
			animationDuration: "0.01ms",
			animationIterationCount: "1",
			transitionDuration: "0.01ms",
		},
	},
	body: {
		backgroundColor: "var(--gray-12)",
		margin: 0,
		padding: 0,
	},
	".radix-themes": {
		color: "var(--gray-1)",
	},
	".radix-themes:where([data-has-background='true'])": {
		backgroundColor: "var(--gray-12)",
	},
	// Use the app's own (overridden) gray tokens, not Radix's unoverridden
	// --slate-* scale: the latter is resolved against Radix's light/dark
	// appearance, so any third-party lib that toggles the document appearance
	// (e.g. a `.dark` class) would flip the nav text colour. See ADR 0008.
	".rt-BaseTabListTrigger": {
		color: "var(--gray-1)",
	},
	".rt-BaseTabListTrigger:where([data-state='active'], [data-active])": {
		color: "var(--gray-3)",
	},
	".rt-TextFieldRoot:where(.rt-variant-surface)": {
		color: "var(--gray-1)",
	},
	".rt-TextFieldInput::placeholder": {
		color: "var(--color-text-placeholder)",
	},
	".rt-Separator": {
		// backgroundColor: "var(--gray-)",
	},
	// ".rt-BaseButton:where(.rt-variant-solid)": {
	// 	backgroundColor: "var(--gray-1)",
	// 	color: "var(--gray-12)",
	// },
	// ".rt-BaseButton:where(.rt-variant-solid):hover": {
	// 	backgroundColor: "var(--gray-3)",
	// 	color: "var(--gray-12)",
	// },
	// ".rt-BaseButton:where(.rt-variant-solid):focus": {
	// 	backgroundColor: "var(--gray-3)",
	// 	color: "var(--gray-12)",
	// },
	// ".rt-BaseButton:where(.rt-variant-solid):active": {
	// 	backgroundColor: "var(--gray-3)",
	// 	color: "var(--gray-12)",
	// },
	"rt-BaseButton:where(.rt-variant-solid):where([data-disabled])": {},
});
